
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps } from 'next';
import ModelPlayground from '../../components/Model/ModelPlayground';
import HeadModule from '../../components/Modules/HeadModule';
import { GERMAN_MODEL } from '../../constants/models';
import { useModelExampleCategories } from '../../hooks/useModelExampleCategories';
import { useModelExamples } from '../../hooks/useModelExamples';
import { fetchModelExampleCategories } from '../api/model/example-categories';
import { fetchModelExamples } from '../api/model/examples';
// noinspection JSUnusedGlobalSymbols
const getStaticProps: GetStaticProps = async () => {
    const modelExamples = (await fetchModelExamples(GERMAN_MODEL.language)) ?? '';
    const modelExampleCategories = (await fetchModelExampleCategories()) ?? '';
    return {
        props: {
            modelExamplesParam: JSON.stringify(modelExamples),
            modelExampleCategoriesParam: JSON.stringify(modelExampleCategories),
        },
        revalidate: 900,
    };
};
interface Props {
    modelExamplesParam: string;
    modelExampleCategoriesParam: string;
}
const GermanModelPlayground = ({ modelExamplesParam, modelExampleCategoriesParam }: Props) => {
    const modelExamples = useModelExamples(modelExamplesParam);
    const modelExampleCategories = useModelExampleCategories(modelExampleCategoriesParam);
    return (<>
      <HeadModule title='meta_title_model_german' description='meta_description_model_german'/>
      <ModelPlayground model={GERMAN_MODEL} modelExamples={modelExamples} modelExampleCategories={modelExampleCategories}/>
    </>);
};
// noinspection JSUnusedGlobalSymbols
export default GermanModelPlayground;

    async function __Next_Translate__getStaticProps__196fbffbba4__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/model/german',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196fbffbba4__ as getStaticProps }
  